import React from 'react';
import {Button, Col, Modal, Row} from 'react-bootstrap';

const SmartEntityModal = ({visible, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <div className={isMobile ? 'd-flex flex-column' : 'd-flex flex-row'}>
                    <span style={{color: '#060606', fontSize: '22px'}}>上架智能体</span>
                    <span style={{
                        color: '#060606',
                        fontSize: isMobile ? '14px' : '18px',
                        alignSelf: 'end',
                        margin: isMobile ? '0' : '0 10px'
                    }}>
                    分享您的智能体，让更多用户收益
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <p style={{color: '#7D7D7D'}}>提交我的智能体，让用户快速获取我的工作流。让玩法传播更快更方便。</p>
                <div style={{maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden'}}>
                    <Row style={{justifyContent: 'center'}}>
                        <Col sm={'4'} className={'mb-2'}>
                            <div style={{
                                backgroundColor: '#42485A',
                                color: '#fff',
                                padding: '10px',
                                borderRadius: '8px'
                            }}>
                              <span style={{
                                  background: '#0AB7CF',
                                  color: '#060606',
                                  width: '38px',
                                  height: '38px',
                                  borderRadius: '50%',
                                  display: 'block',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                  fontSize: '24px',
                                  fontWeight: 'bold',
                                  alignSelf: 'center',
                                  margin: '0 auto',
                                  marginBottom: '10px'
                              }}>1</span>
                                <h6 style={{textAlign: 'center', fontSize: '18px'}}>加入社区</h6>
                                <p style={{
                                    color: '#79878E',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>扫码加入我们的社区</p>
                                <div style={{textAlign: 'center', margin: '10px 0'}}>
                                    <img
                                        src="https://video-translate-web.oss-cn-beijing.aliyuncs.com/shangjiazhinegit.png"
                                        alt="社区二维码" width={100} height={100}/>
                                </div>
                            </div>
                        </Col>
                        <Col sm={'4'} className={'mb-2'}>
                            <div style={{
                                backgroundColor: '#42485A',
                                color: '#fff',
                                padding: '10px', borderRadius: '8px'
                            }}>
                              <span style={{
                                  background: '#0AB7CF',
                                  color: '#060606',
                                  width: '38px',
                                  height: '38px',
                                  borderRadius: '50%',
                                  display: 'block',
                                  textAlign: 'center',
                                  alignContent: 'center',
                                  fontSize: '24px',
                                  fontWeight: 'bold',
                                  alignSelf: 'center',
                                  margin: '0 auto',
                                  marginBottom: '10px'
                              }}>2</span>
                                <h6 style={{textAlign: 'center', fontSize: '18px'}}>分享智能体</h6>
                                <p style={{
                                    color: '#79878E',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>分享要上架的智能体</p>
                            </div>
                        </Col>
                        <Col sm={'4'} className={'mb-2'}>
                            <div style={{
                                backgroundColor: '#42485A',
                                color: '#fff',
                                padding: '10px',
                                borderRadius: '8px'
                            }}>
                            <span style={{
                                background: '#0AB7CF',
                                color: '#060606',
                                width: '38px',
                                height: '38px',
                                borderRadius: '50%',
                                display: 'block',
                                textAlign: 'center',
                                alignContent: 'center',
                                fontSize: '24px',
                                fontWeight: 'bold',
                                alignSelf: 'center',
                                margin: '0 auto',
                                marginBottom: '10px'
                            }}>3</span>
                                <h6 style={{textAlign: 'center', fontSize: '18px'}}>托管完成</h6>
                                <p style={{
                                    color: '#79878E',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>托管优质智能体还能获取SVIP奖励</p>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div style={{marginTop: 10, textAlign: 'center', color: '#8EA3AE', fontSize: '16px'}}>
                    <span>希望大家踊跃参与</span>
                </div>
            </Modal.Body>
            <Modal.Footer style={{background: '#1E2129', borderTopColor: '#707070'}}>
                <Button variant="primary" onClick={onClose} style={{
                    background: 'linear-gradient(90deg,#02C8E3,#963BC8)',
                    border: 'none',
                    padding: '12px 48px',
                    color: '#060606'
                }}>
                    我知道了
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SmartEntityModal;